/**
 * Showcase router
 * 
 */
 
import React from 'react';

// Functions

import Helpers from '../../utils/functions/helpers';

// Layout

import Article from '../layout/article/article';
import Theme from '../layout/theme/theme';
import Hero from '../layout/hero/hero';

// Components

import Meta from '../../components/meta/meta';

// Pages

import NotFound from './404';
import Loading from './loading';

export default class Showcase extends React.Component {

	state = {

		doc: null,
		settings: null,
		notFound: false,
	}

	componentWillMount() {

		this.fetchPage(this.props);
	}

	componentWillReceiveProps(props) {

		this.fetchPage(props);
	}

	componentDidUpdate(prevProps) {
		
		if (this.props.location !== prevProps.location) {

			window.scrollTo(0, 0)
		}
	}

	fetchPage(props) {
		
		if (props.settings != null) {

			const { settings } = props;
			const url = props.match.params.uid === undefined ? '' : props.match.params.uid;

			return props.cms.api.getByUID('showcase', url, {}, (err, doc) => {

				if (doc) {

					// Renaming object keys to support scalable templates
					Helpers.renameObjectKeys(doc.data.body);
					
					this.setState({ doc: doc, settings: settings });
				}
				else {

					this.setState({ notFound: !doc });
				}
			});
		}

		return null;
	}

	render() {
		
		if (this.state.doc) {
			
			const { data } = this.state.doc;
			const { settings } = this.state;
						
			return (

				<React.Fragment>

					<Meta data={data} settings={settings}></Meta>
					<Theme theme={data.theme_class}></Theme>
					
					<Article>

						<Hero layout="bubble" style={data.hero_style}></Hero>
						<h1>{data.title[0].text}</h1>
						
					</Article>
				
				</React.Fragment>
			);
		}
		else if (this.state.notFound) {

			return <NotFound />;
		}

    	return <Loading />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/pages/showcase.js